export const TICKETS_DASHBOARD_GET_TICKETS = 'TICKETS_DASHBOARD_GET_TICKETS';
export const TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS =
    'TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS';
export const TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER =
    'TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER';
